import { editSettingsApi, getSettingsApi } from "api/settings";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  editSettingsFailure,
  editSettingsSuccess,
  getSettingsFailure,
  getSettingsSuccess,
} from "./actions";
import { EDIT_SETTINGS, GET_SETTINGS } from "./actionTypes";

function* getSettingsSaga({ payload }) {
  try {
    const { data } = yield call(getSettingsApi, payload);
    yield put(getSettingsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSettingsFailure(error));
  }
}

// ===================================================
// ===================================================

function* editSettingsSaga({ payload }) {
  try {
    const { data, success } = yield call(editSettingsApi, payload);
    yield put(editSettingsSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تعديل الاعدادات بنجاح");
    }
  } catch (error) {
    console.log(error);
    yield put(editSettingsFailure(error.response.data.errors[0].msg));
    yield payload?.toast?.error(error.response.data.errors[0].msg);
  }
}

// ===================================================
// ===================================================

export function* watchGetSettings() {
  yield takeEvery(GET_SETTINGS, getSettingsSaga);
}

export function* watchEditSettings() {
  yield takeLatest(EDIT_SETTINGS, editSettingsSaga);
}

// ===================================================
// ===================================================

function* settingsSaga() {
  yield all([fork(watchGetSettings)]);
  yield all([fork(watchEditSettings)]);
}

export default settingsSaga;
